interface Props {
  onNext: () => void;
}

// Step 1 of 6: Welcome.
// Editorial hero treatment: large display heading with tight letter-spacing,
// one-line supporting copy in ink2, primary CTA with keyboard hint below.
export function WelcomeStep({ onNext }: Props) {
  return (
    <div className="py-12">
      <p className="display-eyebrow text-primary mb-6">
        Welcome
      </p>

      <h1 className="display-hero text-[64px] sm:text-[72px] text-foreground mb-6">
        Meet <span className="text-primary">UB Remote</span>.
      </h1>

      <p className="text-[17px] leading-[1.55] text-ink2 max-w-[500px] mb-10 font-normal">
        The window your AI works through. Every action shown in plain
        English before it happens. Every credential kept on this device.
        One tap to stop.
      </p>

      <div className="flex items-center gap-5">
        <button
          onClick={onNext}
          className="group inline-flex items-center gap-2.5 bg-primary text-primary-foreground pl-6 pr-5 py-3.5 rounded-lg font-medium text-[14px] shadow-[0_1px_2px_rgba(0,71,255,0.15),0_4px_16px_-4px_rgba(0,71,255,0.35)] hover:shadow-[0_2px_4px_rgba(0,71,255,0.2),0_8px_24px_-4px_rgba(0,71,255,0.45)] hover:bg-primary/95 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
        >
          Get started
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" aria-hidden="true">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>
        <span className="hidden sm:inline text-[12px] text-muted-foreground">
          or press <span className="kbd">Enter</span>
        </span>
      </div>

      <div className="mt-14 pt-8 border-t border-border/60 max-w-[500px]">
        <p className="text-[12px] text-ink3 leading-[1.6]">
          Six short steps. About a minute. You can undo any of them.
        </p>
      </div>
    </div>
  );
}
